import React, {PropTypes} from 'react';
import moment from 'moment';
import {reduxForm, Field} from 'redux-form';
import StandardModal from 'shared/StandardModal.jsx';
import StandardField from 'shared/StandardField.jsx';
import StandardSelectField from 'shared/StandardSelectField.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';

const CaptainManageSquadChangeModal = ({
  childSquadDateTime,
  childEventName,
  childAvailableSquads,
  childrenEntries,
  entryId,
  isBundledChild,
  parentAvailableSquads,
  parentEventName,
  visible,
  startDate,
  endDate,
  handleSubmit,
  onCancel,
  onSubmit,
  onDateChange,
  onTimeChange
}) =>(
  <StandardModal
    title={`Change Squad - ${parentEventName}`}
    visible={visible}
    onCloseClick={onCancel}>
      <div>
        <DisplayIf condition={isBundledChild}>
          <div className="alert alert-info">{'To move a Doubles and Singles date, you must first move the Team entry date.'}</div>
        </DisplayIf>
        <form
          onSubmit={handleSubmit(onSubmit)}>
          <Field
            disabled={isBundledChild}
            name="parentSquadDateTime"
            type="date"
            minDate={startDate}
            maxDate={endDate}
            component={StandardField}
            label="Date"
            onCustomChange={value => onDateChange(entryId, value)}
          />
          <Field
            name="parentSquadId"
            component={StandardSelectField}
            options={parentAvailableSquads}
            label={`Available Times`}
            placeholder={parentAvailableSquads.length ? 'Select an Option' : 'No available times'}
            simpleValue
            searchable
            onCustomChange={value => onTimeChange(entryId, value)}
          />
          <DisplayIf condition={!!childrenEntries.length}>
            <br />
            <h4>{`Change Squad - ${childEventName} to ${moment.parseZone(childSquadDateTime).format('MM/DD/YYYY')}`}</h4>
            {childrenEntries.map((entry, i) =>
              (<Field
                key={i}
                name={`childrenEntries[${i}]['squadId']`}
                component={StandardSelectField}
                options={childAvailableSquads}
                label={`#${i + 1} Available Times For Squad (${entry.teamName})`}
                placeholder={childAvailableSquads.length ? 'Select an Option' : 'No available times'}
                simpleValue
                searchable
              />)
            )}
          </DisplayIf>
          <div className="form-group text-right">
              <button
                type="button"
                className="btn btn-link"
                onClick={() => onCancel()}
              >Cancel</button>
              {` `}
              <button
                type="submit"
                className="btn btn-primary btn-lg"
              ><i className="fa fa-floppy-o" /> {'Save'}</button>
          </div>
        </form>
      </div>
    </StandardModal>
);

CaptainManageSquadChangeModal.propTypes = {
  childSquadDateTime: PropTypes.string,
  childEventName: PropTypes.string,
  childAvailableSquads: PropTypes.arrayOf(PropTypes.object),
  childrenEntries: PropTypes.arrayOf(PropTypes.object),
  entryId: PropTypes.string,
  isBundledChild: PropTypes.bool,
  parentAvailableSquads: PropTypes.arrayOf(PropTypes.object),
  parentEventName: PropTypes.string,
  visible: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  onDateChange: PropTypes.func,
  onTimeChange: PropTypes.func
};

CaptainManageSquadChangeModal.defaultProps = {
  childSquadDateTime: '',
  childEventName: '',
  childAvailableSquads: [],
  childrenEntries: [],
  entryId: '',
  isBundledChild: false,
  parentAvailableSquads: [],
  parentEventName: '',
  visible: false
};

export default reduxForm({
  form: 'captainManageSquadChangeForm'
})(CaptainManageSquadChangeModal);



// WEBPACK FOOTER //
// ./src/features/registration/manage/SquadChangeModal.jsx